import React from 'react'
import Button from 'components/button'
import IntegrationCard from 'views/integrations/components/IntegrationCard'

interface IntegrationProviderViewProps {
  provider: string
  logo: string
  connected: boolean
  redirectUrl: string
  connectingAccount: boolean
  disconnectAccount: (provider: string) => void
}

const IntegrationProviderView: React.FC<IntegrationProviderViewProps> = (props) => {
  const { redirectUrl, connectingAccount, ...cardProps } = props
  return (
    <IntegrationCard {...cardProps} connectingAccount={connectingAccount}>
      <a href={redirectUrl} className={connectingAccount ? 'cursor-not-allowed pointer-events-none' : ''}>
        <Button data-tour="integration-connect-account" disabled={connectingAccount}>
          Connect
        </Button>
      </a>
    </IntegrationCard>
  )
}

export default IntegrationProviderView
